<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'SISTEMAS.LBL_SISTEMAS' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'SISTEMAS.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!sistema">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="10"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'SISTEMAS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <label *ngIf="sistema && sistema.idSistema" class="falso-combo-texto">{{sistema.codigo}}</label>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'SISTEMAS.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombreSistema"
                       [maxlength]="20"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreSistema.invalid">
                  {{ 'SISTEMAS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <label>{{ 'SISTEMAS.LBL_DESCRIPCION' | translate }}</label>
                <textarea id="idDescripcion" name="nomDescripcion" pInputTextarea rows="2"
                          capitalize-reactive maxlength="250"
                          formControlName="descripcion"></textarea>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                  {{ 'SISTEMAS.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <label>{{ 'SISTEMAS.LBL_TOKEN' | translate }}</label>
                <input type="text" pInputText id="idToken"
                       name="nomToken"
                       autocomplete="off" (blur)="validarToken()"
                       formControlName="token"
                       [maxlength]="50"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.token.invalid">
                  {{ 'SISTEMAS.LBL_TOKEN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all" *ngIf="tokExiste">
                  {{ 'SISTEMAS.MSG_TOKENEXISTE' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'SISTEMAS.LBL_INDICADORCREACION' | translate}}" binary="true"
                          id="idIndicadorCreacion"
                          name="nomIndicadorCreacion"
                          formControlName="indicadorCreacion"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'SISTEMAS.LBL_INDICADORCONSULTA' | translate}}" binary="true"
                          id="idIndicadorConsulta"
                          name="nomIndicadorConsulta"
                          formControlName="indicadorConsulta"></p-checkbox>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'SISTEMAS.LBL_INDICADORACTUALIZACION' | translate}}" binary="true"
                          id="idIndicadorActualizacion"
                          name="nomIndicadorActualizacion"
                          formControlName="indicadorActualizacion"></p-checkbox>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
